import { render, staticRenderFns } from "./TagGather.vue?vue&type=template&id=60d423b0&scoped=true&"
import script from "./TagGather.vue?vue&type=script&lang=js&"
export * from "./TagGather.vue?vue&type=script&lang=js&"
import style0 from "./TagGather.vue?vue&type=style&index=0&id=60d423b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d423b0",
  null
  
)

export default component.exports